<template>
  <div id="app">
    <Header1 />
    <Page2 />
    <!-- <HeaderPage @openIntro="openIntroduct" @openSwiper="openImgSwiper"/> -->
    <FooterPage />
    <Introduction ref="introduction" />
    <!-- <ImgSwiper ref="imgswiper" /> -->
  </div>
</template>
<script>
// 设置rem 函数
// function setRem() {
//   let size = 75;
//   let scale = window.screen.width / 1920;
//   if(window.screen.width<=750) {
//     size = 75;
//     scale = window.screen.width / 750;
//   }
//   // 给根元素设置font-size
//   document.documentElement.style.fontSize =
//   size * Math.min(scale, 2) + "px";
// }
import Header1 from './components/Header.vue'
import Page2 from './components/Page2.vue'
// import HeaderPage from './components/HeaderPage.vue'
import FooterPage from './components/FooterPage.vue'
import Introduction from './components/Introduction.vue'
// import ImgSwiper from './components/ImgSwiper.vue'
export default {
  components: {
    Header1,
    Page2,
    // HeaderPage,
    FooterPage,
    Introduction,
    // ImgSwiper
  },
  methods: {
    openIntroduct(e) {
      this.$refs.introduction.visible = e
    },
    openImgSwiper(e) {
      this.$refs.imgswiper.visible = e
    }
  },
  // mounted() {
  //   setRem()
  //   window.addEventListener("resize", setRem());
  // },
  // beforeDestroy() {
  //   window.removeEventListener("resize", setRem());
  // },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
#app{
  width: 100%;
  height: 100%;
  overflow: auto;
}
</style>